// extracted by mini-css-extract-plugin
module.exports = {"collapsible__items":"styles_collapsible__items__jIXjK"};